<template>
  <div id="app" :class="[vueAppClasses , showFeatureNotification ? 'stop-page-scroll' : '']">
    <SpeakolExportToast />
    <FeatureOnboarding v-if="showFeatureNotification" :feature="feature" @completed="exitFeatureNotification"></FeatureOnboarding>
    <tour v-if="isAuthenticated && showTour" @completed="tourCompleted"></tour>
    <div v-if="isAuthenticated && showBonusPopup">
      <speakol-athar-bonus-popup
        :show="showBonusPopup"
        v-on:hide-bonus-popup="goToCampaignsCreation"
      />
    </div>
    <router-view @setAppClasses="setAppClasses"/>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import Tour from '@/components/tour'
import FeatureOnboarding from '@/components/FeatureOnboarding'
import SpeakolExportToast from '@/components/SpeakolExportToast'
import {mapGetters} from 'vuex'
import SpeakolAtharBonusPopup from '@/components/popups/SpeakolAtharBonusPopup.vue'

export default {
  data () {
    return {
      feature: {},
      vueAppClasses: [],
      showTour: false,
      showFeatureNotification: false,
      showBonusPopup: false
    }
  },
  components: {
    SpeakolAtharBonusPopup,
    Tour,
    SpeakolExportToast,
    FeatureOnboarding
  },
  watch: {
    feature (newVal) {
      if (newVal) {
        this.showFeatureNotification = true
      }
    },
    '$store.state.authentication.user' () {
      const user = this.$store.getters['authentication/user']
      const isMaintenanceModeEnabled = (process.env.VUE_APP_MAINTENANCE_MODE === 'true') || false
      if (!isMaintenanceModeEnabled) {
        this.updateHotjar(user)
        this.updateIntercom(user)
        this.displayTour()
        this.displayBonusPopup()
      }
    },
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    '$parent.isGeneralError' (newVal) {
      if (newVal === true) {
        this.$vs.notify({
          time: 5000,
          color: 'warning',
          title: 'Oppps ...',
          text: 'something went wrong, please try again or click the popoup to contact us.',
          click: () => {
            document.location.href = 'mailto:dev@speakol.com'
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'authentication/isAuthenticated',
      user: 'authentication/user'
    })
  },
  async mounted () {

    this.initIntercom()
    const isMaintenanceModeEnabled = (process.env.VUE_APP_MAINTENANCE_MODE === 'true') || false
    if (!isMaintenanceModeEnabled) {
      this.feature = await this.getFeature()
    }
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)
    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async getFeature () {
      const user = this.$store.getters['authentication/user']
      if (!user) {
        return null
      }

      const response = await window.axios.get('/notifications-center/list', {
        params: {
          tags: this.$constants.ONBOARDING_NOTIFICATIONS_TAGS,
          is_viewed: 0
        }
      })

      return response.data.payload && response.data.payload.data ? response.data.payload.data[0] : null
    },
    initIntercom () {
      this.$intercom.boot({})
    },
    updateIntercom (user) {
      if (user) {
        this.$intercom.update({
          'email': user.email,
          'name': user.name,
          'phone': user.phone,
          'user_hash': (user.information.intercom || {}).user_hash || null,
          'Contact Type': 'Advertisers'
        })
      }
    },
    updateHotjar (user) {
      if (user) {
        this.$hj('identify', user.id.toString(), {
          'email': user.email,
          'name': user.name,
          'phone': user.phone,
          'Contact Type': 'Advertisers',
          'Is Admin': !!user.origin
        })
      }
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    displayTour () {
      const isSeen = this.isSliderSeen()
      if (!isSeen) {
        this.showTour = true
      }
    },
    isSliderSeen () {
      if (this.user && 'information' in this.user && this.user['information']['slider_seen'] === true) {
        return true
      }

      return false
    },
    async tourCompleted () {
      try {
        await window.axios.post('/users/hide-slider')

        this.showTour = false

        this.$store.commit('authentication/USER_COMPLETED_TOUR', true)
      } catch (error) {
        return false
      }
    },

    displayBonusPopup () {
      const utm = this.user && this.user.utm ? JSON.parse(this.user.utm) : null
      const utmParameters = utm ? utm.parameters : {}

      if (utmParameters.utm_campaign !== 'Athar_speakol') {
        return
      }

      if (!this.isBonusPopupSeen()) {
        this.showBonusPopup = true
      }
    },
    isBonusPopupSeen () {
      return !!(this.user &&
        'information' in this.user &&
        this.user['information']['bonus_seen'] === true)
    },
    goToCampaignsCreation () {
      this.hideBonusPopup()

      setTimeout(() => {
        if (this.$route.path !== '/campaigns/create') {
          this.$router.push('/campaigns/create')
        }
      }, 0)
    },
    async hideBonusPopup () {
      try {
        await window.axios.post('/users/hide-bonus-popup')
        this.showBonusPopup = false

        this.$store.commit('authentication/USER_BONUS_SEEN', true)
      } catch (error) {
        return false
      }
    },

    exitFeatureNotification () {
      this.showFeatureNotification = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .stop-page-scroll {
    max-height: 100vh;
    overflow-y: hidden;
  }
</style>

